import { widgetVoiceMessageTypeLayout, } from '../components/AlertWizard/Components/VoiceMessageTypeLayout';
import { widgetVoiceOptionsLayout } from '../components/AlertWizard/Components/VoiceOptionsLayout';
import { widgetCustomLayout } from '../components/AlertWizard/Components/WizardCustomLayout';
import { widgetDeliveryMethods } from './WidgetDeliveryMethods';
import { widgetDeliveryOrder } from './WidgetDeliveryOrder';
import { widgetExternalRecipients } from './WidgetExternalRecipients';
import { widgetLongMessage } from './WidgetLongMessage';
import { widgetMessageInfo } from './WidgetMessageInfo';
import { widgetPhinIdentifier } from './WidgetPhinIdentifier';
import { widgetRecipients } from './WidgetRecipients';
import { widgetRecordMessage } from './WidgetRecordMessage';
import { widgetSender } from './WidgetSender';
import { widgetTotalRecipients } from './WidgetTotalRecipients';
export const alertFormWidgets = [
    widgetCustomLayout,
    widgetDeliveryMethods,
    widgetDeliveryOrder,
    widgetExternalRecipients,
    widgetLongMessage,
    widgetMessageInfo,
    widgetPhinIdentifier,
    widgetRecipients,
    widgetRecordMessage,
    widgetSender,
    widgetTotalRecipients,
    widgetVoiceMessageTypeLayout,
    widgetVoiceOptionsLayout,
];
